import React from "react";
import { VStack } from "@UI/Components/Stack/Stack";
import { Button } from "@UI/Components/Button/Button";
import { Box } from "@UI/Components/Box/Box";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { Icon } from "@UI/Components/Icon/Icon";
import { useDisclosure } from "@UI/hooks/useDisclosure";

import { ArrowRight } from "@UI/Components/Icons/ArrowRight";
import { ServiceRequestStatusStepIndicator } from "./ServiceRequestStatusStepIndicator";
import { ServiceRequestStatusModal } from "./ServiceRequestStatusModal";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";

export default function ServiceRequestNextSteps() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <VStack h="full" alignItems="start">
      <Heading as="h4" fontSize={{ base: "1.5rem", lg: "1.725rem" }}>
        <FormattedMessage
          {...messages["serviceRequest.statusStep.cardTitle"]}
        />
      </Heading>
      <Box
        background="white"
        p={{ base: "16px", lg: "20px" }}
        borderRadius="10px"
        width={{ base: "full", lg: "320px", xl: "360px" }}
      >
        <Button
          variant="ghost"
          w="full"
          justifyContent="space-between"
          display={{ base: "flex", lg: "none" }}
          _hover={{ background: "initial" }}
          onClick={onOpen}
          p="0"
        >
          <Text m="0" sx={{ "text-wrap": "auto" }} textAlign="start">
            <FormattedMessage
              {...messages["serviceRequest.statusStep.whatAreTheNextSteps"]}
            />
          </Text>
          <Icon as={ArrowRight} width="16px" height="16px" ml="5px" />
        </Button>
        <ServiceRequestStatusModal isOpen={isOpen} onClose={onClose} />
        <ServiceRequestStatusStepIndicator
          display={{ base: "none", lg: "block" }}
        />
      </Box>
    </VStack>
  );
}
